/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
const loader = document.querySelector('#cart-loader');
const cartItemNumber = document.querySelector('#cart-item-numbers');
function displayLoading(){
  cartNumber.classList.add("hidden_element")
  loader.classList.add("display")
}

function hideLoading(){
  cartNumber.classList.remove("hidden_element")
  loader.classList.remove("display")
}
const cartNumber = document.getElementById('cart-item-numbers');
document.addEventListener('cart:refresh', () => {
  displayLoading()
  fetch("".concat(window.routes.cartUrl, '.js'))
  .then( response => response.json())
  .then( response => cartNumber.innerHTML = response.item_count )
  .then( () => hideLoading())
})

if (window.screen.width <= 768){

  //Footer accordion
  const footerMenuTitles = document.querySelectorAll('.footer_title_container')
  footerMenuTitles.forEach((title) => {
    title.addEventListener('click', () => {
      title.nextElementSibling.classList.toggle('display_element')
      title.firstElementChild.classList.toggle('rotate_arrow')
    })
  })


  //Prevent redirect to search page on search icon click (mobile)
  const searchButton = document.querySelector(".Header__Search-Container")
  searchButton.addEventListener('click', event => {
    if (event){
      event.preventDefault()
    }

    const pageOverlayElement = document.querySelector('.PageOverlay')
    pageOverlayElement.classList.remove('is-visible')
})


}

const addItemToCart = (productData) => {
  fetch(window.routes.cart_add_url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: productData
  })
  .then((response) => {
    if(response.ok){
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      var detail = {
        message: "Cart Updated",
        status: "success"
      }
    }else{
      var detail = {
        message: "There was an error adding your product to your cart",
        status: "error"
      }
    }
    let event = new CustomEvent('document:notification', { detail })
    document.dispatchEvent(event)
  })
}

const addToCartButton = document.querySelector('.logoscorp-button-ajax'); // First, we switch the status of the button

if(addToCartButton){
  addToCartButton.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    var formElement = document.querySelector('form[action*="/cart/add"]');
    var formdata = new FormData(formElement);
  
    const productData = JSON.stringify({
      id: formdata.get('id'),
      quantity: formdata.get('quantity')
    });
    addItemToCart(productData)
  })
}
let t 
let toast = document.querySelector('.notification');
let toast_message = document.querySelector('.notification_message');
document.addEventListener('document:notification', (event) => {
  toast.classList = 'notification'
  toast.classList.add(event.detail.status)
  toast_message.innerHTML = event.detail.message
  clearTimeout(t);
  toast.style.transform = 'translateX(0)'
  t = setTimeout(() => {
    toast.style.transform = 'translateX(-400px)'
  }, 5000);
})